import clsx from "clsx";
import { FunctionComponent } from "react";

import VergeHamburgerIcon from "@ui/components/brand/theverge/VergeHamburgerIcon";
import * as navStyles from "@ui/components/brand/theverge/VergeStandardNavigation/VergeStandardNavigation.css";
import { VergeNavigationVariants } from "@ui/components/navigation/Navigation/Navigation";
import { useNavigationContext } from "@ui/context/navigation-context";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";
import { useOptionalNotificationsDrawerContext } from "@voxmedia/duet-context/context/notifications-context";

import * as styles from "./HamburgerButton.css";

interface Props {
  variant: VergeNavigationVariants;
}

const HamburgerButton: FunctionComponent<Props> = ({ variant }) => {
  const analytics = useAnalytics();
  const { openDrawer, drawerId } = useNavigationContext();
  const notificationsDrawer = useOptionalNotificationsDrawerContext();
  const handleMoreBtnClick = () => {
    notificationsDrawer?.closeDrawer();
    openDrawer();
    analytics?.emit({
      event: "navigation_click",
      navigation_click: { name: "more button" },
    });
  };
  return (
    <button
      onClick={handleMoreBtnClick}
      className={clsx(styles.moreButton, navStyles.navTextColor[variant])}
      aria-controls={drawerId}
      aria-label="Open Drawer"
    >
      <div className={clsx(styles.moreInnerContainer[variant])}>
        <span className={clsx(styles.moreIconContainer)}>
          <VergeHamburgerIcon className={styles.moreIcon} />
        </span>
      </div>
    </button>
  );
};

export default HamburgerButton;
